export default "__VITE_ASSET__c3432362__"